import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["alreadySharedIn", "isSharedEverywhere", "isLoading"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Popover, UnavailableInLens } from '@infl-ts/ui-advocate-components';
import { CoinsIcon, FacebookIcon, LinkedinIcon } from '@infl-ts/ui-advocate-icons';
import { useToggle } from '@infl-ts/util-hooks';
import { isMobileBrowser } from '@infl-ts/util-platform';
import Check from '@mui/icons-material/Check';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Twitter from '@mui/icons-material/Twitter';
import { Box, Button, MenuItem, paperClasses, SwipeableDrawer, useMediaQuery } from '@mui/material';
import * as A from 'fp-ts/Array';
import { absurd, constVoid, pipe } from 'fp-ts/function';
import * as Number from 'fp-ts/number';
import * as O from 'fp-ts/Option';
import * as Ord from 'fp-ts/Ord';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var PROVIDERS_ORDER = {
  twitter: 0,
  linkedin: 1,
  facebook: 2
};

var ShareItem = function ShareItem(_ref) {
  var points = _ref.points,
      providerIcon = _ref.providerIcon,
      isShared = _ref.isShared,
      label = _ref.label;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      width: 1
    },
    "data-element": "Box",
    "data-component": "ShareItem",
    "data-source-file": "share-button.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        color: function color(t) {
          return isShared ? t.palette.text.disabled : t.palette.text.primary;
        }
      },
      "data-element": "Box",
      "data-component": "ShareItem",
      "data-source-file": "share-button.tsx",
      children: [isShared ? /*#__PURE__*/_jsx(Check, {}) : providerIcon, /*#__PURE__*/_jsx(Translation, {
        "data-element": "Translation",
        "data-component": "ShareItem",
        "data-source-file": "share-button.tsx",
        children: function children(t) {
          return t(label);
        }
      })]
    }), !isShared && points && /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        ml: 5,
        alignItems: 'center'
      },
      children: [/*#__PURE__*/_jsx(CoinsIcon, {
        sx: {
          ml: 1,
          fontSize: 16
        }
      }), points.toLocaleString()]
    })]
  });
};

var providerIconSize = 28;

var ProviderButton = function ProviderButton(_ref2) {
  var points = _ref2.points,
      provider = _ref2.provider,
      isShared = _ref2.isShared;

  switch (provider) {
    case 'linkedin':
      return /*#__PURE__*/_jsx(ShareItem, {
        points: points,
        providerIcon: /*#__PURE__*/_jsx(LinkedinIcon, {
          sx: function sx(t) {
            return {
              fill: t.palette.other.linkedIn,
              fontSize: providerIconSize
            };
          }
        }),
        isShared: isShared,
        label: "".concat(isShared ? 'Shared' : 'Share', " on LinkedIn")
      });

    case 'twitter':
      return /*#__PURE__*/_jsx(ShareItem, {
        points: points,
        providerIcon: /*#__PURE__*/_jsx(Twitter, {
          sx: function sx(t) {
            return {
              fill: t.palette.other.twitter,
              fontSize: providerIconSize
            };
          }
        }),
        isShared: isShared,
        label: "".concat(isShared ? 'Shared' : 'Share', " on Twitter")
      });

    case 'facebook':
      return isMobileBrowser() ? /*#__PURE__*/_jsx(ShareItem, {
        providerIcon: /*#__PURE__*/_jsx(FacebookIcon, {
          sx: {
            fontSize: providerIconSize
          }
        }),
        label: 'Unavailable on mobile'
      }) : /*#__PURE__*/_jsx(ShareItem, {
        points: points,
        providerIcon: /*#__PURE__*/_jsx(FacebookIcon, {
          sx: function sx(t) {
            return {
              fill: t.palette.other.facebook,
              fontSize: providerIconSize
            };
          }
        }),
        isShared: isShared,
        label: "".concat(isShared ? 'Shared' : 'Share', " on Facebook")
      });

    default:
      return absurd(provider);
  }
};

var NetworksMenuItems = function NetworksMenuItems(_ref3) {
  var alreadySharedIn = _ref3.alreadySharedIn,
      enabledNetworks = _ref3.enabledNetworks,
      isLoading = _ref3.isLoading,
      onShare = _ref3.onShare,
      _ref3$handleClose = _ref3.handleClose,
      handleClose = _ref3$handleClose === void 0 ? constVoid : _ref3$handleClose,
      points = _ref3.points;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: enabledNetworks.map(function (provider) {
      var isShared = alreadySharedIn.includes(provider);
      var isFacebook = provider === 'facebook';
      return /*#__PURE__*/_jsx(MenuItem, {
        disabled: isShared || isLoading || isFacebook && isMobileBrowser(),
        onClick: function onClick() {
          onShare(provider);
          handleClose();
        },
        children: /*#__PURE__*/_jsx(ProviderButton, {
          points: points,
          isShared: isShared,
          provider: provider
        })
      }, provider);
    })
  });
};

var OpenProvidersButton = function OpenProvidersButton(_ref4) {
  var alreadySharedIn = _ref4.alreadySharedIn,
      isSharedEverywhere = _ref4.isSharedEverywhere,
      isLoading = _ref4.isLoading,
      props = _objectWithoutProperties(_ref4, _excluded);

  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "OpenProvidersButton",
    "data-source-file": "share-button.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        variant: alreadySharedIn.length > 0 ? 'text' : 'contained',
        disableElevation: true,
        sx: {
          mr: 2
        },
        size: "large",
        disabled: isSharedEverywhere || isLoading,
        endIcon: /*#__PURE__*/_jsx(KeyboardArrowDownIcon, {})
      }, props), {}, {
        children: alreadySharedIn.length > 0 ? t('Share again') : t('Share post')
      }));
    }
  });
};

var byProvider = pipe(Number.Ord, Ord.contramap(function (account) {
  return PROVIDERS_ORDER[account];
}));

var ShareButton = function ShareButton(_ref5) {
  var points = _ref5.points,
      networks = _ref5.networks,
      alreadySharedIn = _ref5.alreadySharedIn,
      _onShare = _ref5.onShare,
      isLoading = _ref5.isLoading,
      checkCount = _ref5.checkCount;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isOpen = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      open = _useToggle2$.on,
      close = _useToggle2$.off,
      toggle = _useToggle2$.toggle;

  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });
  var enabledNetworks = pipe(Object.entries(networks), A.filterMap(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        provider = _ref7[0],
        enabled = _ref7[1];

    return enabled ? O.some(provider) : O.none;
  }), A.sort(byProvider));
  var isSharedEverywhere = enabledNetworks.every(function (network) {
    return alreadySharedIn.includes(network);
  });
  return /*#__PURE__*/_jsx(UnavailableInLens, {
    tooltip: true,
    "data-element": "UnavailableInLens",
    "data-component": "ShareButton",
    "data-source-file": "share-button.tsx",
    children: isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(OpenProvidersButton, {
        alreadySharedIn: alreadySharedIn,
        isSharedEverywhere: isSharedEverywhere,
        isLoading: isLoading,
        onClick: toggle
      }), /*#__PURE__*/_jsx(SwipeableDrawer, {
        sx: _defineProperty({}, "& .".concat(paperClasses.root), {
          p: 2
        }),
        open: isOpen,
        onClose: close,
        onOpen: open,
        anchor: "bottom",
        disablePortal: true,
        disableSwipeToOpen: true,
        children: /*#__PURE__*/_jsx(NetworksMenuItems, {
          alreadySharedIn: alreadySharedIn,
          enabledNetworks: enabledNetworks,
          isLoading: isLoading,
          onShare: function onShare(provider) {
            if (checkCount()) _onShare(provider);
            close();
          },
          handleClose: close,
          points: points
        })
      })]
    }) : /*#__PURE__*/_jsx(Popover, {
      placement: "bottom-start",
      noPadding: true,
      zIndex: function zIndex(t) {
        return t.zIndex.aboveDrawer;
      },
      disabled: isSharedEverywhere || isLoading,
      content: function content(close) {
        return /*#__PURE__*/_jsx(NetworksMenuItems, {
          alreadySharedIn: alreadySharedIn,
          enabledNetworks: enabledNetworks,
          isLoading: isLoading,
          onShare: function onShare(provider) {
            if (checkCount()) _onShare(provider);
            close();
          },
          handleClose: close,
          points: points
        });
      },
      children: /*#__PURE__*/_jsx(OpenProvidersButton, {
        alreadySharedIn: alreadySharedIn,
        isSharedEverywhere: isSharedEverywhere,
        isLoading: isLoading
      })
    })
  });
};

export default ShareButton;